import script from "./simple-textfield.vue?vue&type=script&lang=ts&setup=true"
export * from "./simple-textfield.vue?vue&type=script&lang=ts&setup=true"

import "./simple-textfield.vue?vue&type=style&index=0&id=70e58f51&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e58f51"]])

export default __exports__